import PickUpMain from './pages/PickUp'
import PickUpEform from './pages/PickUpEform'
import CompletePickUp from './components/CompletePickUp'
import { store } from './store'

const router = {
  name: 'pickup',
  path: 'pickup',
  component: PickUpMain,
  children: [
    {
      path: '/',
      name: 'pickup',
      component: PickUpEform,
      meta: {
        showMenu: false,
        requiresAuth: true,
        requiresPermission: true,
        action: 77,
        titleHeader: 'Completar formulario'
      }
    },
    {
      name: 'pickup-detail',
      path: 'detail',
      component: CompletePickUp,
      beforeEnter: (to, from, next) => {
        if (store.hashEform) {
          return next()
        }
        next({ name: 'pickup' })
      },
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 77,
        titleHeader: ''
      }
    }
  ]
}

export default router
